// Extracted verbatim from the v3 monolith (see BIRDSEYE.md module split plan).

import { PF_NS } from './constants.js';
import { toArray, toInt, parseCsv, normalizeText } from './utils.js';
import { setControlValue, getControlFilterValue } from './controls.js';

export var _urlPrefix = function () {
  var safeKey = String(this.instanceKey)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_-]/g, '-');

  return PF_NS + '-' + safeKey + '-';
};

export var _clearOwnUrlParams = function () {
  var url = new URL(window.location.href);
  var params = url.searchParams;
  var prefix = this._urlPrefix();
  var changed = false;

  var keysToDelete = [];
  params.forEach(function (_value, key) {
    if (key.indexOf(prefix) === 0) {
      keysToDelete.push(key);
    }
  });

  keysToDelete.forEach(function (key) {
    params.delete(key);
    changed = true;
  });

  if (!changed) {
    return;
  }

  var next = url.pathname + (params.toString() ? '?' + params.toString() : '') + url.hash;
  window.history.replaceState({}, '', next);
};

// Normalized values the field's controls can take (select options included).
function knownOptionValues(controls) {
  var known = Object.create(null);
  controls.forEach(function (control) {
    if (control.tagName && control.tagName.toLowerCase() === 'select') {
      toArray(control.options).forEach(function (opt) {
        known[normalizeText(opt.value)] = true;
      });
      return;
    }
    known[normalizeText(getControlFilterValue(control))] = true;
  });
  return known;
}

// Links written before one-param-per-value joined values with commas ("tech,finance").
// Split such a value only when it is not itself an option and every part is one, so a
// value that contains a comma ("Logistics, Supply") or free text stays whole.
function splitLegacyCsv(raw, known) {
  if (raw.indexOf(',') === -1 || known[normalizeText(raw)]) {
    return [raw];
  }
  var parts = parseCsv(raw);
  var allKnown = parts.length > 1 && parts.every(function (part) {
    return known[normalizeText(part)];
  });
  return allKnown ? parts : [raw];
}

export var _restoreStateFromUrl = function () {
  var params = new URLSearchParams(window.location.search);
  var prefix = this._urlPrefix();

  var fieldControls = {};

  this.filterControls.forEach(function (control) {
    var field = normalizeText(control.getAttribute('data-pf-filter'));
    if (!field) {
      return;
    }

    if (!fieldControls[field]) {
      fieldControls[field] = [];
    }

    fieldControls[field].push(control);
  });

  Object.keys(fieldControls).forEach(function (field) {
    var raws = params.getAll(prefix + 'f-' + field).filter(Boolean);
    if (!raws.length) {
      return;
    }

    var known = knownOptionValues(fieldControls[field]);
    var values = [];
    raws.forEach(function (raw) {
      values = values.concat(splitLegacyCsv(raw, known));
    });
    fieldControls[field].forEach(function (control) {
      setControlValue(control, values);
    });
  });

  this.searchControls.forEach(function (control, index) {
    var key = prefix + 's-' + index;
    var value = params.get(key);
    if (value !== null) {
      control.value = value;
    }
  });

  var logicValue = normalizeText(params.get(prefix + 'logic') || '');
  if (logicValue === 'and' || logicValue === 'or') {
    this.currentLogic = logicValue;

    this.logicToggles.forEach(function (control) {
      var type = (control.type || '').toLowerCase();
      if (type === 'checkbox') {
        var onVal = normalizeText(control.getAttribute('data-pf-logic-on') || 'or');
        control.checked = onVal === logicValue;
      } else if (type === 'radio') {
        control.checked = normalizeText(control.value) === logicValue;
      } else {
        control.value = logicValue;
      }
    });
  }

  var page = toInt(params.get(prefix + 'page'), 1);
  this.currentPage = page;
};

export var _writeStateToUrl = function (state) {
  var url = new URL(window.location.href);
  var params = url.searchParams;
  var prefix = state.urlPrefix;

  var keysToDelete = [];
  params.forEach(function (_value, key) {
    if (key.indexOf(prefix) === 0) {
      keysToDelete.push(key);
    }
  });

  keysToDelete.forEach(function (key) {
    params.delete(key);
  });

  var fieldKeys = Object.keys(state.filtersByField);
  fieldKeys.forEach(function (field) {
    var terms = state.filtersByField[field] || [];
    if (!terms.length) {
      return;
    }

    // One param per value: a comma-joined list split "Logistics, Supply" in two on restore.
    terms.forEach(function (term) {
      params.append(prefix + 'f-' + field, term.raw);
    });
  });

  state.searchGroups.forEach(function (group) {
    params.set(prefix + 's-' + group.id, group.raw);
  });

  if (state.logic !== this.defaultLogic) {
    params.set(prefix + 'logic', state.logic);
  }

  if (this.currentPage > 1) {
    params.set(prefix + 'page', String(this.currentPage));
  }

  var next = url.pathname + (params.toString() ? '?' + params.toString() : '') + url.hash;
  window.history.replaceState({}, '', next);
};

